import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "bham_admin_token";

export const submitApplication = async (data) => {
  const res = await axios.post(`${API}/applications`, data);
  return res.data;
};

export const adminLogin = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  const token = res.data.token;
  localStorage.setItem(TOKEN_KEY, token);
  return token;
};

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminListApplications = async (filters = {}) => {
  const params = {};
  if (filters.training_type) params.training_type = filters.training_type;
  if (filters.level) params.level = filters.level;
  if (filters.status) params.status = filters.status;
  if (filters.q) params.q = filters.q;
  const res = await axios.get(`${API}/admin/applications`, {
    params,
    headers: authHeader(),
  });
  return res.data;
};

export const adminGetStats = async () => {
  const res = await axios.get(`${API}/admin/stats`, { headers: authHeader() });
  return res.data;
};

export const adminUpdateStatus = async (id, status) => {
  const res = await axios.patch(
    `${API}/admin/applications/${id}/status`,
    { status },
    { headers: authHeader() }
  );
  return res.data;
};

export const adminExportCsvUrl = () => `${API}/admin/applications/export`;

export const adminDownloadCsv = async () => {
  const res = await axios.get(`${API}/admin/applications/export`, {
    headers: authHeader(),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "bham-applications.csv");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
